import { render, staticRenderFns } from "./SubscripForm.vue?vue&type=template&id=214f121a&"
import script from "./SubscripForm.vue?vue&type=script&lang=js&"
export * from "./SubscripForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports